import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

// Linear regression function
function getLinearRegression(data) {
  const n = data.length;
  const x = data.map((d, i) => i); // Using index as x-axis (numerical)
  const y = data.map((d) => d.y);

  const sumX = x.reduce((a, b) => a + b, 0);
  const sumY = y.reduce((a, b) => a + b, 0);
  const sumXY = x.reduce((sum, xi, i) => sum + xi * y[i], 0);
  const sumXX = x.reduce((sum, xi) => sum + xi * xi, 0);

  const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
  const intercept = (sumY - slope * sumX) / n;

  return data.map((d, i) => ({
    x: d.x, // Keep original date as x-value
    y: slope * i + intercept,
  }));
}

const DatewiseRegression = ({ chartUtils }) => {
  const [series, setSeries] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      if (!chartUtils?.series || !Array.isArray(chartUtils.series)) {
        setSeries([{ name: "No Data", type: "line", data: [] }]);
        return;
      }

      const formattedData = chartUtils.series.map((point) => ({
        x: new Date(point.date).getTime(),
        y: Number(point.field),
      }));

      // Calculate regression line
      const regressionLine = getLinearRegression(formattedData);
      console.log("regressionLine", regressionLine);

      // Prepare series
      const series = [
        {
          name: "Actual Data",
          type: "scatter",
          data: formattedData,
        },
        {
          name: "Regression Line",
          type: "line",
          data: regressionLine,
        },
      ];
      console.log("series", series);
      setSeries(series);
      setError(null);
    } catch (err) {
      console.error("Error rendering regression chart:", err);
      setError("Failed to render chart. Please check your data.");
      setSeries([{ name: "Error", type: "line", data: [] }]);
    }
  }, [chartUtils]);

  const options = {
    chart: {
      type: "line",
      height: 350,
      zoom: { enabled: true },
    },

    xaxis: {
      type: "datetime",
      labels: {
        format: "dd MMM yyyy",
        datetimeUTC: false,
      },
      title: { text: chartUtils?.axis?.x },
    },
    stroke: {
      curve: "smooth",
      width: [0, 2],
    },
    markers: {
      size: 5,
      colors: "#fff",
      strokeColors: ["#008FFB"],
      strokeWidth: 3,
      hover: {
        size: 7,
      },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "center",
      fontSize: "12px",
      fontWeight: 600,
      labels: {
        colors: "#333",
      },
      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },

    dataLabels: {
      enabled: true,
      offsetY: -10,
      background: {
        enabled: true,
        borderRadius: 4,
        borderWidth: 1,
        borderColor: "#fff",
        padding: 5,
      },

      formatter: (value) => value.toFixed(2), // Always 2 decimal points
    },

    yaxis: {
      labels: {
        formatter: (value) => value.toFixed(2),
      },
      title: { text: chartUtils?.axis?.y },
    },
    tooltip: {
      shared: true,
    },
  };

  if (error) {
    return (
      <div
        style={{
          height: "500px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p style={{ color: "red" }}>{error}</p>
      </div>
    );
  }

  return <Chart options={options} series={series} height={350} type="line" />;
};

export default DatewiseRegression;
